<ng-template [ngIf]="showDetails">
	<div *ngIf="showLanguageMessage" class="obg-password-strength-language">
		<span class="ico-information-circle"></span>
		<span>{{ languageMessageKey | translate }}</span>
	</div>

	<strong>{{ "register.password.tooltip-title" | translate }}</strong>
	<ul>
		<li [class.strong]="passwordLengthValid">{{ "register.password.invalid-length" | translate }}</li>
		<li [class.strong]="passwordContainsNumber">{{ "register.password.no-number" | translate }}</li>
		<li [class.strong]="passwordContainsCasing">{{ "register.password.incorrect-case" | translate }}</li>
		<li *ngIf="showContainSpecialChar" [class.strong]="passwordContainsSpecialChar">
			{{ "register.password.special-char" | translate }}
		</li>
	</ul>
	<div *ngIf="passwordStrengthName">{{ "reset-password.password-strength-" + passwordStrengthName | translate }}</div>
	<obg-progress-bar
		content-body
		[mode]="progressBarMode"
		[class.empty]="passwordStrength === PasswordStrength.Empty"
		[class.invalid]="passwordStrength === PasswordStrength.Invalid"
		[class.fair]="passwordStrength === PasswordStrength.Fair"
		[class.good]="passwordStrength === PasswordStrength.Good"
		[class.strong]="passwordStrength === PasswordStrength.Strong"
		[value]="passwordStrength || PasswordStrength.Empty"
		[maxValue]="4"
		hideValues
	>
	</obg-progress-bar>
	<p>{{ "register.password.tooltip-" + passwordStrengthName | translate }}</p>
</ng-template>
<div *ngIf="!showDetails && passwordStrengthName" [attr.class]="passwordStrengthName">
	{{ "reset-password.password-strength-" + passwordStrengthName | translate }}
</div>
